<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="section-1">
<h1>2</h1>
<p>We’re riding from the east to the west of Belfast.</p>
<p>“Inspector Black said you’d tell me the truth, and be reasonable about payment.”</p>
<p>“Best to tell the truth.”</p>
<p>“How reasonable?”</p>
<p>“You on benefit?”</p>
<p>“Yes.”</p>
<p>“Paid weekly?”</p>
<p>“Yes.”</p>
<p>“Got a big jam jar?”</p>
<p>“Got a small one.”</p>
<p>“Get a big one, enjoy the jam, put fifty pence a week in it until I find your son.”</p>
<p>“Think one jampot’ll be enough?”</p>
<p>“Oh ye of little faith. If I’m getting nowhere I’ll tell you.”</p>
<p>Union Jacks flutter.</p>
<p>“So, where do you live?”</p>
<p>She tells me. I stop in a street of houses built for mill workers when the linen industry was in full swing.</p>
<p>She’s about to get out. “Come and share Sabbath Dinner with me.”</p>
<p>“Why?”</p>
<p>“You can tell me about Steven.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?19b4d85a